// extracted by mini-css-extract-plugin
module.exports = {"alert":"admin-portal__ConnectionAlert__alert"};